export default {
  ACCOUNT_NOT_FOUND: "ไม่พบอีเมลนี้อยู่ในระบบ กรุณาตรวจสอบอีเมลของคุณอีกครั้ง",
  INTERNAL_SERVER_ERROR: "ขออภัย! มีบางอย่างผิดพลาด กรุณาลองใหม่อีกครั้ง หรือ ติดต่อเราที่ hello@hippo.cc",
  PASSWORD_TOO_SHORT: "รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัวอักษร",
  PASSWORDS_NOT_MATCH: "รหัสผ่านไม่ตรงกัน",
  INVALID_EMAIL_OR_PASSWORD: "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
  EXISTING_EMAIL: "อีเมลนี้ได้ถูกใช้ไปแล้ว",
}
